import { render, staticRenderFns } from "./SalesOrderPaymentMailCallback.vue?vue&type=template&id=7387d728&scoped=true&"
import script from "./SalesOrderPaymentMailCallback.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderPaymentMailCallback.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrderPaymentMailCallback.vue?vue&type=style&index=0&id=7387d728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7387d728",
  null
  
)

export default component.exports